import React, { useState } from "react";
import { TriangleAlert } from "lucide-react";

import Button from "../../Button";
import VideoPlayerModal from "../../modals/common/VideoPlayerModal";
import Alert from "../../Alert";
import PutOnSensorImage from "src/assets/images/cgm/connection-journey/put-on-sensor-thumbnail.png";

import { EXTERNAL_URLS } from "src/constants/common";

type PlaceSensorStepProps = {
  onContinue: () => void;
};

const PlaceSensorStep: React.FC<PlaceSensorStepProps> = ({ onContinue }) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <div className="px-4 py-4 flex flex-col items-center gap-4 w-full">
      <h1 className="text-2xl font-semibold text-black">Put on the sensor</h1>
      <p className="text-sm text-gray-500 text-center">
        Watch the below video or follow the steps to put on your sensor.
      </p>
      <div className="relative mt-10" onClick={() => setShowModal(true)}>
        <img
          src={PutOnSensorImage}
          alt="Put on Sensor"
          className="w-full h-auto"
        />
      </div>

      <Alert
        title="Important Note"
        description="Don’t unlock your sensor before putting it the sensor on your skin"
        icon={<TriangleAlert className="w-4 h-4" />}
      />

      <div className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-100">
        <Button
          onClick={onContinue}
          variant="contained"
          rounded="full"
          fullWidth
        >
          I have placed sensor
        </Button>
      </div>

      <VideoPlayerModal
        show={showModal}
        title="How to Put on the Sensor"
        handleClose={() => setShowModal(false)}
        videoUrl={EXTERNAL_URLS.CGM_HOW_TO_PUT_ON_SENSOR}
        type="youtube"
      />
    </div>
  );
};

export default PlaceSensorStep;
